import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xxl-8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#nid-verification",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "NID Verification")
  ])
], -1)
const _hoisted_3 = {
  id: "nid-verification",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9 py-6" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Date of Birth", -1)
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "National ID")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "col-md-2 mt-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "col-md-2 mt-2"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-forward" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Assessor Information")
  ])
], -1)
const _hoisted_17 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_18 = { class: "collapse show" }
const _hoisted_19 = { class: "card-body border-top p-9 py-6" }
const _hoisted_20 = { class: "row d-flex" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = {
  for: "file_name",
  class: "fs-6 fw-bold form-label"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 row d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-9 required form-label" }, "Assessor Image"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-camera",
      style: {"font-size":"4vh"}
    })
  ])
], -1)
const _hoisted_24 = { id: "preview" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "col-md-9" }
const _hoisted_27 = { class: "row mt-3 d-flex" }
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Email", -1)
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Father's Name", -1)
const _hoisted_34 = { class: "row mt-3 d-flex" }
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mother's Name", -1)
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Passport")
], -1)
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Driving License")
], -1)
const _hoisted_41 = { class: "row mt-3" }
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mobile")
], -1)
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Birth Registration Number")
], -1)
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gender")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select gender", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", { value: "Male" }, "Male", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("option", { value: "Female" }, "Female", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", { value: "Other" }, "Other", -1)
const _hoisted_52 = { class: "col-md-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Religion", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Religion", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("option", { value: "Islam" }, "Islam", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", { value: "Hindu" }, "Hindu", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "Christian" }, "Christian", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "Buddhist" }, "Buddhist", -1)
const _hoisted_59 = { class: "row mt-3" }
const _hoisted_60 = { class: "col-md-8" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Address")
], -1)
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present District")
], -1)
const _hoisted_64 = { class: "row mt-3" }
const _hoisted_65 = { class: "col-md-8" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Address")
], -1)
const _hoisted_67 = { class: "col-md-4" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent District")
], -1)
const _hoisted_69 = {
  key: 2,
  class: "card mb-5 mb-xxl-8"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#nid-verification",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Educational Information")
  ])
], -1)
const _hoisted_71 = {
  id: "educational_info",
  class: "collapse show"
}
const _hoisted_72 = { class: "collapse show" }
const _hoisted_73 = { class: "card-body border-top px-9 pt-4 pb-0" }
const _hoisted_74 = { class: "table" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Institute Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Level of Education"),
    /*#__PURE__*/_createElementVNode("th", null, "Subject"),
    /*#__PURE__*/_createElementVNode("th", null, "Passing Year"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus text-light" }, null, -1)
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = {
  key: 3,
  class: "card mb-5 mb-xxl-8"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#nid-verification",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Professional Information")
  ])
], -1)
const _hoisted_84 = {
  id: "professional_info",
  class: "collapse show"
}
const _hoisted_85 = { class: "collapse show" }
const _hoisted_86 = { class: "card-body border-top px-9 pt-4 pb-0" }
const _hoisted_87 = { class: "table" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Designation"),
    /*#__PURE__*/_createElementVNode("th", null, "Organization"),
    /*#__PURE__*/_createElementVNode("th", null, "Address"),
    /*#__PURE__*/_createElementVNode("th", null, "Experience From"),
    /*#__PURE__*/_createElementVNode("th", null, "Experience To"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_89 = ["onUpdate:modelValue"]
const _hoisted_90 = ["onUpdate:modelValue"]
const _hoisted_91 = ["onUpdate:modelValue"]
const _hoisted_92 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus text-light" }, null, -1)
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = {
  key: 4,
  class: "card mb-5 mb-xxl-8"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#nid-verification",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Add Certificates")
  ])
], -1)
const _hoisted_98 = {
  id: "certificate_info",
  class: "collapse show"
}
const _hoisted_99 = { class: "collapse show" }
const _hoisted_100 = { class: "card-body border-top px-9 pt-4 pb-0" }
const _hoisted_101 = { class: "table" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Certificate Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Organization Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Year"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1)
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus text-light" }, null, -1)
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = {
  key: 5,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainer_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Assessor Specification")
  ])
], -1)
const _hoisted_109 = {
  id: "trainer_information",
  class: "collapse show"
}
const _hoisted_110 = { class: "collapse show" }
const _hoisted_111 = { class: "card-body border-top p-9 py-6" }
const _hoisted_112 = { class: "row" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-4-light" }, "BTEB Certification", -1)
const _hoisted_114 = { class: "col-md-4 mt-8" }
const _hoisted_115 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is BTEB Registered? ", -1)
const _hoisted_117 = { class: "col-md-4" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "BTEB Registration Number", -1)
const _hoisted_119 = { class: "col-md-4" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Skill Level")
], -1)
const _hoisted_121 = { class: "row mt-3" }
const _hoisted_122 = { class: "col-md-4" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Occupation")
], -1)
const _hoisted_124 = { class: "col-md-4" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Pedagogy Level Achieved")
], -1)
const _hoisted_126 = { class: "col-md-4" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Which Pedagogy Part Completed?")
], -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Select Pedagogy Part ", -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("option", { value: "trainer" }, "Trainer", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("option", { value: "assessor" }, "Assessor", -1)
const _hoisted_131 = { class: "row mt-6" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold-light" }, "NSDA Certification", -1)
const _hoisted_133 = { class: "col-md-4 mt-8" }
const _hoisted_134 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is the Trainer NSDA Certified? ", -1)
const _hoisted_136 = { class: "col-md-4" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "NSDA Registration Number", -1)
const _hoisted_138 = { class: "col-md-4" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Skill Level")
], -1)
const _hoisted_140 = { class: "row mt-3" }
const _hoisted_141 = { class: "col-md-4" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Occupation")
], -1)
const _hoisted_143 = { class: "col-md-4" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Pedagogy Level Achieved")
], -1)
const _hoisted_145 = { class: "col-md-4" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Which Pedagogy Part Completed?")
], -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Select Pedagogy Part ", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("option", { value: "trainer" }, "Trainer", -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("option", { value: "assessor" }, "Assessor", -1)
const _hoisted_150 = { class: "row mt-6" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("h4", null, "Other Information", -1)
const _hoisted_152 = { class: "col-md-6 mt-3" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", { class: "align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Area of Expertise")
], -1)
const _hoisted_154 = {
  key: 6,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#user_account",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Add User Account")
  ])
], -1)
const _hoisted_156 = {
  id: "user_account",
  class: "collapse show"
}
const _hoisted_157 = { class: "collapse show" }
const _hoisted_158 = { class: "card-body border-top p-9 py-6" }
const _hoisted_159 = { "data-kt-stepper-element": "content" }
const _hoisted_160 = { class: "row" }
const _hoisted_161 = { class: "col-md-6" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Email", -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "" }, "Password")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      name: "password",
      class: "fv-plugins-message-container invalid-feedback"
    }, "System will generate a password and send to your email.")
  ])
], -1)
const _hoisted_164 = {
  key: 7,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_165 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#entity_institute",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Training Partner & Institute")
  ])
], -1)
const _hoisted_166 = {
  id: "entity_institute",
  class: "collapse show"
}
const _hoisted_167 = { class: "collapse show" }
const _hoisted_168 = { class: "card-body border-top p-9 py-6" }
const _hoisted_169 = { class: "row" }
const _hoisted_170 = { class: "col-md-3" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_173 = { class: "col-md-3" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Training Partner")
], -1)
const _hoisted_175 = { class: "col-md-3" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_177 = { class: "col-md-3" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_179 = { key: 8 }
const _hoisted_180 = { class: "d-flex" }
const _hoisted_181 = ["data-kt-indicator"]
const _hoisted_182 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_183 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_184 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_185 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[43] || (_cache[43] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssessorSchema
  }, {
    default: _withCtx(() => [
      (_ctx.showNidInfo)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_el_form_item, {
                        prop: "date",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.employee.dob,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employee.dob) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            type: "date",
                            name: "dob",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "dob",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.nid,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.employee.nid) = $event)),
                        name: "nid",
                        class: "form-control form-control-sm",
                        type: "string"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "nid",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    (_ctx.showTrainerInfo == false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nidverification(_ctx.employee.nid))),
                            type: "button",
                            class: "btn btn-success mt-6 p-3",
                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                          }, [
                            _createTextVNode(" Verify "),
                            _hoisted_12
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showTrainerInfo == false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.verifySkip && _ctx.verifySkip(...args))),
                            type: "button",
                            class: "btn btn-danger mt-6",
                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                          }, [
                            _createTextVNode(" Skip NID "),
                            _hoisted_14
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.load]
          ])
        : _createCommentVNode("", true),
      (_ctx.showTrainerInfo == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_Field, {
                            name: "file_name",
                            ref: "fileInput",
                            accept: "image/jpeg",
                            onChange: _ctx.updatePhoto,
                            type: "file",
                            class: "form-control",
                            id: "file_name"
                          }, null, 8, ["onChange"]),
                          (_ctx.url)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.url
                              }, null, 8, _hoisted_25))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "entity_logo",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.employee.name,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.employee.name) = $event)),
                            type: "text",
                            name: "name",
                            class: "form-control form-control-sm",
                            rows: "3"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "name",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.employee.email,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.employee.email) = $event)),
                            name: "email",
                            class: "form-control form-control-sm",
                            type: "email"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "email",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.employee.father_name,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.employee.father_name) = $event)),
                            type: "text",
                            name: "father_name",
                            class: "form-control form-control-sm",
                            rows: "3"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "father_name",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.employee.mother_name,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.employee.mother_name) = $event)),
                            type: "text",
                            name: "mother_name",
                            class: "form-control form-control-sm",
                            rows: "3"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "mother_name",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.employee.passport,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.employee.passport) = $event)),
                            name: "passport",
                            class: "form-control form-control-sm",
                            value: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.employee.driving_license,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.employee.driving_license) = $event)),
                            name: "driving_license",
                            class: "form-control form-control-sm",
                            value: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.mobile,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.employee.mobile) = $event)),
                        name: "mobile",
                        class: "form-control form-control-sm",
                        value: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "mobile",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.bcn,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.employee.bcn) = $event)),
                        name: "bcn",
                        class: "form-control form-control-sm",
                        value: "",
                        type: "number"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createVNode(_component_Field, {
                        name: "gender",
                        modelValue: _ctx.employee.gender,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.employee.gender) = $event)),
                        class: "form-select form-select-lg",
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_48,
                          _hoisted_49,
                          _hoisted_50,
                          _hoisted_51
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "gender",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_Field, {
                        name: "religion",
                        modelValue: _ctx.employee.religion,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.employee.religion) = $event)),
                        class: "form-select",
                        style: {"height":"40px","width":"100%"},
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_54,
                          _hoisted_55,
                          _hoisted_56,
                          _hoisted_57,
                          _hoisted_58
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "religion",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.present_address,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.employee.present_address) = $event)),
                        name: "present_address",
                        class: "form-control form-control-sm"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Present District",
                        modelValue: _ctx.employee.present_district,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.employee.present_district) = $event)),
                        style: {"width":"100%"},
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: district.id,
                              label: district.district_name_eng,
                              value: district.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.permanent_address,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.employee.permanent_address) = $event)),
                        name: "permanent_address",
                        id: "permanent_address",
                        rows: "10",
                        autocomplete: "off",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _hoisted_68,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Permanent District",
                        modelValue: _ctx.employee.permanent_district,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.employee.permanent_district) = $event)),
                        name: "permanent_district",
                        style: {"width":"100%"},
                        filterable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: district.id,
                              label: district.district_name_eng,
                              value: district.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTrainerInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("table", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educational_details, (data, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.educational_details[index].institute_name) = $event),
                              name: "education_details",
                              class: "form-control form-control-sm"
                            }, null, 8, _hoisted_76), [
                              [_vModelText, _ctx.educational_details[index].institute_name]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_select, {
                              type: "text",
                              modelValue: _ctx.educational_details[index].level_of_education,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.educational_details[index].level_of_education) = $event),
                              name: "educational_details",
                              class: "form-select-solid",
                              placeholder: "Select Level of Education"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationLabel, (info) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: info,
                                    label: info,
                                    value: info
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128)),
                                _createTextVNode(" > ")
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.educational_details[index].subject) = $event),
                              name: "education_details",
                              class: "form-control form-control-sm"
                            }, null, 8, _hoisted_77), [
                              [_vModelText, _ctx.educational_details[index].subject]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_select, {
                              type: "text",
                              modelValue: _ctx.educational_details[index].passing_year,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.educational_details[index].passing_year) = $event),
                              name: "education_details",
                              class: "form-select-solid",
                              placeholder: "Select Year"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromYear, (year) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: year,
                                    label: year,
                                    value: year
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(year), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128)),
                                _createTextVNode(" > ")
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            (index < 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.addEducation && _ctx.addEducation(...args))),
                                  class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                }, _hoisted_79))
                              : _createCommentVNode("", true),
                            (index >= 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.removeEducation && _ctx.removeEducation(...args))),
                                  class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                }, _hoisted_81))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTrainerInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("table", _hoisted_87, [
                    _hoisted_88,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professional_details, (data, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.professional_details[index].designation) = $event),
                              name: "education_details",
                              class: "form-control form-control-sm"
                            }, null, 8, _hoisted_89), [
                              [_vModelText, _ctx.professional_details[index].designation]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.professional_details[index].organization) = $event),
                              name: "professional_details",
                              class: "form-control form-control-sm"
                            }, null, 8, _hoisted_90), [
                              [_vModelText, _ctx.professional_details[index].organization]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.professional_details[index].address) = $event),
                              name: "education_details",
                              class: "form-control form-control-sm"
                            }, null, 8, _hoisted_91), [
                              [_vModelText, _ctx.professional_details[index].address]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_select, {
                              type: "text",
                              modelValue: _ctx.professional_details[index].exp_from,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.professional_details[index].exp_from) = $event),
                              name: "education_details",
                              class: "form-select-solid",
                              placeholder: "Select Year"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromYear, (year) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: year,
                                    label: year,
                                    value: year
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(year), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_select, {
                              type: "text",
                              modelValue: _ctx.professional_details[index].exp_to,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.professional_details[index].exp_to) = $event),
                              name: "education_details",
                              class: "form-select-solid",
                              placeholder: "Select Year"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromYear, (year) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: year,
                                    label: year,
                                    value: year
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(year), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128)),
                                _createTextVNode(" > ")
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            (index < 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addProfession && _ctx.addProfession(...args))),
                                  class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                }, _hoisted_93))
                              : _createCommentVNode("", true),
                            (index >= 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.removeProfession && _ctx.removeProfession(...args))),
                                  class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                }, _hoisted_95))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTrainerInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
            _hoisted_97,
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("table", _hoisted_101, [
                    _hoisted_102,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (data, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_Field, {
                              modelValue: _ctx.certificates[index].certificate_name,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.certificates[index].certificate_name) = $event),
                              name: `certificates[${index}].certificate_name`,
                              class: "form-control form-control-sm"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_Field, {
                              modelValue: _ctx.certificates[index].organization_name,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.certificates[index].organization_name) = $event),
                              name: `certificates[${index}].organization_name`,
                              class: "form-control form-control-sm"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.certificates[index].year,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.certificates[index].year) = $event),
                              name: `certificates[${index}].year`,
                              class: "form-select-solid",
                              placeholder: "Select Year"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromYear, (year) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: year,
                                    label: year,
                                    value: year
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(year), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                          ]),
                          _createElementVNode("td", null, [
                            (index < 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addcertificate && _ctx.addcertificate(...args))),
                                  class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                }, _hoisted_104))
                              : _createCommentVNode("", true),
                            (index >= 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.removecertificate && _ctx.removecertificate(...args))),
                                  class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                }, _hoisted_106))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTrainerInfo == true || _ctx.createAssessor)
        ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
            _hoisted_108,
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _hoisted_113,
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("label", _hoisted_115, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          name: "is_bteb_registered",
                          onChange: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.bteb_registered && _ctx.bteb_registered(...args)))
                        }, null, 32),
                        _hoisted_116
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_117, [
                      _hoisted_118,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "bteb_registration_number",
                        modelValue: _ctx.entity_assessor.bteb_registration_number,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.entity_assessor.bteb_registration_number) = $event)),
                        onBlur: _ctx.checkBteb,
                        class: "form-control form-control-sm",
                        rows: "3"
                      }, null, 8, ["modelValue", "onBlur"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "bteb_registration_number",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.entity_assessor.skill_level_bteb,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.entity_assessor.skill_level_bteb) = $event)),
                        name: "skill_level_bteb",
                        class: "form-control form-control-sm"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _hoisted_123,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.entity_assessor.occupation_bteb,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.entity_assessor.occupation_bteb) = $event)),
                        name: "occupation_bteb",
                        class: "form-control form-control-sm"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_124, [
                      _hoisted_125,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.entity_assessor.pedagogy_level_bteb,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.entity_assessor.pedagogy_level_bteb) = $event)),
                        name: "pedagogy_level_bteb",
                        class: "form-control form-control-sm"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_126, [
                      _hoisted_127,
                      _createVNode(_component_Field, {
                        name: "pedagogy_part_achieved_bteb",
                        modelValue: _ctx.entity_assessor.pedagogy_part_achieved_bteb,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.entity_assessor.pedagogy_part_achieved_bteb) = $event)),
                        class: "form-select",
                        style: {"height":"40px","width":"100%"},
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_128,
                          _hoisted_129,
                          _hoisted_130
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _hoisted_132,
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("label", _hoisted_134, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          name: "is_nsda_certified",
                          onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.nsda_certified && _ctx.nsda_certified(...args)))
                        }, null, 32),
                        _hoisted_135
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_136, [
                      _hoisted_137,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nsda_registration_number",
                        modelValue: _ctx.entity_assessor.nsda_registration_number,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.entity_assessor.nsda_registration_number) = $event)),
                        class: "form-control form-control-sm",
                        rows: "3"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "nsda_registration_number",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_138, [
                      _hoisted_139,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.entity_assessor.skill_level_nsda,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.entity_assessor.skill_level_nsda) = $event)),
                        name: "skill_level_nsda",
                        class: "form-control form-control-sm"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("div", _hoisted_141, [
                      _hoisted_142,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.entity_assessor.occupation_nsda,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.entity_assessor.occupation_nsda) = $event)),
                        name: "occupation_nsda",
                        class: "form-control form-control-sm"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_143, [
                      _hoisted_144,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.entity_assessor.pedagogy_level_nsda,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.entity_assessor.pedagogy_level_nsda) = $event)),
                        name: "pedagogy_level",
                        class: "form-control form-control-sm"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _createVNode(_component_Field, {
                        name: "pedagogy_part_achieved_nsda",
                        modelValue: _ctx.entity_assessor.pedagogy_part_achieved_nsda,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.entity_assessor.pedagogy_part_achieved_nsda) = $event)),
                        class: "form-select",
                        style: {"height":"40px","width":"100%"},
                        "data-control": "select2",
                        "data-placeholder": "Select...",
                        "data-allow-clear": "true",
                        "data-hide-search": "true",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_147,
                          _hoisted_148,
                          _hoisted_149
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _hoisted_151,
                    _createElementVNode("div", _hoisted_152, [
                      _hoisted_153,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.entity_assessor.area_of_expertise,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.entity_assessor.area_of_expertise) = $event)),
                        type: "textarea",
                        name: "area_of_expertise",
                        class: "form-control form-control-sm"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTrainerInfo == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
            _hoisted_155,
            _createElementVNode("div", _hoisted_156, [
              _createElementVNode("div", _hoisted_157, [
                _createElementVNode("div", _hoisted_158, [
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _createElementVNode("div", _hoisted_161, [
                        _hoisted_162,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.employee.email,
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.employee.email) = $event)),
                          name: "employeeEmail",
                          class: "form-control form-control-sm",
                          type: "email",
                          readonly: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _hoisted_163
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTrainerInfo == true || _ctx.createAssessor == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
            _hoisted_165,
            _createElementVNode("div", _hoisted_166, [
              _createElementVNode("div", _hoisted_167, [
                _createElementVNode("div", _hoisted_168, [
                  _createElementVNode("div", _hoisted_169, [
                    _createElementVNode("div", _hoisted_170, [
                      _hoisted_171,
                      _hoisted_172,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Tranche",
                        modelValue: _ctx.entityInstitute.tranche_id,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.entityInstitute.tranche_id) = $event)),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche, (trans) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: trans.id,
                              label: trans.label,
                              value: trans.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(trans.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_173, [
                      _hoisted_174,
                      _createVNode(_component_el_select, {
                        style: {"width":"100%"},
                        class: "form-select-solid",
                        placeholder: "Select Partner",
                        filterable: "",
                        modelValue: _ctx.entityInstitute.entity_info_id,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.entityInstitute.entity_info_id) = $event)),
                        onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.trainingInstitute()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: 
                      '[' + info.entity_short_name + '] - ' + info.entity_name
                    ,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_175, [
                      _hoisted_176,
                      _createVNode(_component_el_select, {
                        style: {"width":"100%"},
                        class: "form-select-solid",
                        placeholder: "Select Training Institute",
                        modelValue: _ctx.entityInstitute.institute_info_id,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.entityInstitute.institute_info_id) = $event)),
                        filterable: "",
                        onChange: _ctx.courseInfo,
                        "value-key": "id"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (data) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: data.id,
                              label: 
                      '[' + data.short_name + '] - ' + data.institute_name
                    ,
                              value: data.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString('[' + data.institute_name + '] - ' + data.institute_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_177, [
                      _hoisted_178,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Course",
                        modelValue: _ctx.entityInstitute.course_id,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.entityInstitute.course_id) = $event)),
                        name: "course_id",
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: '[' + info.code + '] - ' + info.course_name,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("[" + _toDisplayString(info.code) + "]-" + _toDisplayString(info.course_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showTrainerInfo == true || _ctx.createAssessor == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
            _createElementVNode("div", _hoisted_180, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-success",
                  type: "submit"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_182, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_183, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_184, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_185
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_181)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}